import {
  DeliveryColumnTypes,
  DeliveryLineWithDelivery,
} from 'src/app/delivery-data/delivery-data.model';

import { DateRange } from '../../../shared/models/date-range.model';

export const gbmColumns = [
  DeliveryColumnTypes.deliveryDate,
  DeliveryColumnTypes.externalProductId,
  DeliveryColumnTypes.productTitle,
  DeliveryColumnTypes.unitQuantity,
  DeliveryColumnTypes.gbmBaseUnit,
  DeliveryColumnTypes.productQuantity,
  DeliveryColumnTypes.unitVolumeType,
  DeliveryColumnTypes.allShipToIds,
  DeliveryColumnTypes.externalDeliveryId,
] as const;

export type GbmOverviewViewModel = Pick<
  DeliveryLineWithDelivery,
  (typeof gbmColumns)[number] | 'id' | 'deliveryId' | 'shipToId'
>;

export interface GbmOverviewDataFilters {
  locations: number[];
  search: string;
  dateRange: DateRange;
}
